import React from "react";
import styled from "styled-components";
import { useAppContext } from "../../../context/AppContext";
import SummaryDropdown from "../../molecules/SummaryDropdown/SummaryDropdown";
import DiscountCode from "../../molecules/DiscountCode/DiscountCode";

const BasketAdditionalData = () => {
  const { basket } = useAppContext();

  return basket ? (
    <div>
      <AdditionalData>
        <div>Suma częściowa</div>
        <div>
          {basket.itemsamount.toFixed(2)} {basket.currency.symbol}
        </div>
      </AdditionalData>
      <AdditionalData>
        <div>Kosz dostawy</div>
        <div>
          {basket.grossshippingcost.toFixed(2)} {basket.currency.symbol}
        </div>
      </AdditionalData>
      <AdditionalData>
        <div>Podatek</div>
        <div>
          {basket.taxamount.toFixed(2)} {basket.currency.symbol}
        </div>
      </AdditionalData>
      <AdditionalData>
        <div style={{ fontWeight: "700" }}>W sumie</div>
        <Summary>
          {basket.grossamount.toFixed(2)} {basket.currency.symbol}
        </Summary>
        {basket.transactionlines[0].discountrate ? (
          <DiscountInfo>
            <p>
              Zawiera{" "}
              {Math.abs(Number(basket.transactionlines[0].discountrate)) * 100}%
              rabatu{" "}
            </p>
          </DiscountInfo>
        ) : null}
      </AdditionalData>
      {!!basket.backorderquantity && (
        <AdditionalData>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
              paddingTop: "10px",
              borderTop: "1px solid #ccc",
            }}
          >
            <div style={{ fontSize: "11px" }}>
              *Ponieważ co najmniej jeden z produktów ma wydłużony czas
              realizacji, całe zamówienie zostanie zrealizowane po
              skompletowaniu
            </div>
          </div>
        </AdditionalData>
      )}
      <SummaryDropdown text={"Dodaj kod zniżkowy"}>
        <DiscountCode />
      </SummaryDropdown>
    </div>
  ) : null;
};

export default BasketAdditionalData;

const AdditionalData = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  font-family: "Open Sans", sans-serif;
  color: #666666;
  padding: 8px 0;
  font-size: 12px;
`;

const Summary = styled.div`
  font-weight: bold;
  margin-top: 5px;
`;

const DiscountInfo = styled.div`
  width: 100%;
  color: red;
  text-align: right;
  font-weight: 700;
`;
